import classNames from 'classnames';

import type { Question, ScreenerQuestionBank } from '@api/instant_survey/types';
import { getQuestionTypeIcon } from '@helpers';
import { Button, Card } from '@utilities';

import { getQuestionTypeLabel } from '../../utilities';
import { renderTextWithBlankTokens } from './utilities/helpers';
import styles from './_index.module.scss';

interface BankViewProps {
  bank: ScreenerQuestionBank;
  onPreviewQuestion: (question: Question) => void;
}

const BankView = ({ bank, onPreviewQuestion }: BankViewProps) => (
  <div className={styles['bank-view-grid']}>
    {bank.questions.length === 0 && (
      <p className={styles['bank-view-empty']}>
        There are no screener questions available for this bank yet.
      </p>
    )}
    {bank.questions.map((question) => {
      const hasScreenerLabel = Boolean(question.screenerLabel);
      const title = hasScreenerLabel ? question.screenerLabel : question.text;

      return (
        <div className={styles['bank-view-card-wrapper']} key={question.id}>
          <Card className={styles['bank-view-card']} padding="large">
            <div>
              <span
                className={classNames(styles['bank-view-title'], {
                  [styles['bank-view-title-bold']]: hasScreenerLabel,
                })}
              >
                {renderTextWithBlankTokens(title, `question-${question.id}-title`)}
              </span>
              {hasScreenerLabel && (
                <p className={styles['bank-view-description']}>
                  {renderTextWithBlankTokens(question.text, `question-${question.id}-description`)}
                </p>
              )}
            </div>
            <div className={styles['bank-view-footer']}>
              <span>
                {getQuestionTypeIcon(question.type)}
                {getQuestionTypeLabel(question.type)}
              </span>
              <Button
                onClick={() => onPreviewQuestion(question)}
                text="Preview"
                variant="secondary"
              />
            </div>
          </Card>
        </div>
      );
    })}
  </div>
);

export default BankView;
